import { ref, watch, nextTick, reactive, computed } from '@vue/composition-api'
import tools from '@/sag-core/tools'
import store from '@/store'

export const defaultOptions = ()=>{
    return {
      multiple: false,
      lineNumber: true,
      selectCheckBox: true,
      pageLength: 10
    }
}
export default function(props, emit){

    // 初始選項
    const cptOptions = computed(()=>{
        return Object.assign(defaultOptions(), props.options)
    })

    // 光標
    let nowClickIndex = 0
    let currentCursortCell = null
    let cells = null

    const searchTerm = ref('')
    const pageLength = ref(cptOptions.value.pageLength)

    const current = reactive(props.GridData.current)

    const filterActive = (event, filterOptions)=>{
      event.stopPropagation()
      filterOptions.enabled = !filterOptions.enabled
    }

    // table config
    const tableColumns = props.GridData.columns
    const tableRows = props.GridData.isChild ? props.GridData.filterRows : props.GridData.rows

    // 資料列集合改變時觸發
    props.GridData.dataChangeEvent[props.GridData.name] = (selfRows)=>{
        tools.debug.log({tag: 'eventsOccur', title: '事件發生順序查詢', content: 'dataChangeEvent rows len: ' + props.GridData.rows.length}, props.GridData.name, props.GridData)
        const current = props.GridData.current
        const rows = tableRows
        const pageIndex = current.pageIndex < rows.length ? current.pageIndex : rows.length - 1
        const index = current.index < rows.length ? current.index : rows.length - 1
        current.pageIndex = pageIndex
        current.index = index
        let mainIndex = 0
        if(selfRows.length > 0){
            if(index === pageIndex){
                current.data = selfRows[index]
                mainIndex = index
            }
            else{
                current.data = selfRows[0]
                mainIndex = 0
            }
        }
        else{
            props.GridData.currentDataInit()
        }
        refreshCursor(mainIndex)
    }
        
    const onRowClick = (params)=>{
        props.GridData.current.data = params.row
        props.GridData.current.index = params.row.originalIndex
        props.GridData.current.pageIndex = params.pageIndex

        refreshCursor(props.GridData.current.pageIndex)
    }

    // 光標刷新
    const refreshCursor = (index)=>{
        currentCursortCell && currentCursortCell.classList.remove('Cursort-cell')
        currentCursortCell = document.querySelector(`#vgt-${props.GridData.name} tbody tr:nth-child(${(index || 0) + 1})`)
        currentCursortCell && currentCursortCell.classList.add('Cursort-cell')
    
        // 目前資料變更事件Invoke
        props.GridData.eventInvoke(props.GridData.currentDataChangeEvent)
    }
    
    const previewModalOpen = ()=>{
        emit('previewModalOpenEvent', true)
    }
    
    const editModalOpen = ()=>{
        emit('editModalOpenEvent', true)
    }
    
    const deleteData = ()=>{
        emit('deleteDataEvent')
    }

    props.GridData.currentDataChangeEvent[`${props.name}/sagOpenWindow`] = ()=>{
        tools.debug.log({tag: 'test', title: '開窗點擊觸發事件', content: '點擊內容'}, props.GridData.current)
    }

    return {
        searchTerm,
        pageLength,
        filterActive,
        deleteData,
        onRowClick,
        tableColumns,
        tableRows,
        previewModalOpen,
        editModalOpen,
        cptOptions
    }
}